(function () {
    'use strict';

    /*
      Login Controller Module
      -------------------------------------------------------------------------- */

    angular
        .module('UserApp.login', [])

        /**
          * UserLoginController - login a user in application
          *
          * @inject __Form
          * @inject __Auth
          * @inject appServices
          * @inject __Utils
          * 
          * @return void
          *-------------------------------------------------------- */

        .controller('UserLoginController', [
            '__Form',
            '__Auth',
            'appServices',
            '__Utils',
            '$scope',
            function (__Form, __Auth, appServices, __Utils, $scope) {

                var scope = this;

                scope = __Form.setup(scope, 'form_user_login', 'loginData', {
                    secured: true
                });

                scope.show_captcha = false;
                scope.request_completed = false;
                scope.guestLogin = false;
                scope.site_key = __globals.getAppImmutables('recaptcha_site_key');

                if (_.has($scope.ngDialogData, 'guestOrder')
                    && $scope.ngDialogData.guestOrder == true) {
                    scope.guestLogin = true;
                }

                /**
                  * Get login attempts for this client ip
                  *
                  * @return void
                  *---------------------------------------------------------------- */

                __Form.fetch('user.login.attempts').success(function (responseData) {

                    appServices.processResponse(responseData, null, function (reactionCode) {
                        scope.show_captcha = responseData.data.show_captcha;
                        scope.selectUser = responseData.data.selectUser;
                        scope.request_completed = true;

                    });
                });


                scope.addUserData = function (value) {

                    if (value) {
                        scope.loginData.email = scope.selectUser[value]['email'];
                        scope.loginData.password = scope.selectUser[value]['password']
                    }
                };

                /**
                  * Fetch captch url
                  *
                  * @return string
                  *---------------------------------------------------------------- */

                scope.getCaptchaURL = function () {
                    return __Utils.apiURL('security.captcha') + '?ver=' + Math.random();
                };

                /**
                  * Refresh captch 
                  *
                  * @return void
                  *---------------------------------------------------------------- */

                scope.refreshCaptcha = function () {
                    scope.captchaURL = scope.getCaptchaURL();
                };

                scope.captchaURL = scope.getCaptchaURL();

                /**
                * Submit login form action
                *
                * @return void
                *---------------------------------------------------------------- */

                scope.submit = function () {

                    scope.isInActive = false;

                    __Form.process('user.login', scope).success(function (responseData) {

                        var requestData = responseData.data;

                        if (responseData.reaction != 1) {
                            // reset recaptcha field
                            scope[scope.ngFormModelName].recaptcha = null;
                        }

                        appServices.processResponse(responseData, {
                            error: function () {

                                // scope.isInActive = requestData.isInActive;

                                scope.show_captcha = requestData.show_captcha;

                                // reset password field
                                scope[scope.ngFormModelName].password = "";

                                // Check if show captcha exist then refresh captcha
                                if (scope.show_captcha) {
                                    scope[scope.ngFormModelName].confirmation_code = "";
                                    scope.refreshCaptcha();
                                }

                            },
                            otherError: function (reactionCode) {

                                scope.isInActive = requestData.isInActive;

                                // If reaction code is Server Side Validation Error Then 
                                // Unset the form fields
                                if (reactionCode == 3) {
                                    // Check if show captcha exist then refresh captcha
                                    if (scope.show_captcha) {
                                        scope.refreshCaptcha();
                                    }
                                } else if (reactionCode == 10) {
                                    if (requestData.auth_info.authorized) {
                                        window.location = window.appConfig.appBaseURL;
                                    }
                                }

                            }
                        },
                            function () {

                                __Auth.checkIn(requestData.auth_info, function () {

                                    if (requestData.intendedUrl) {

                                        __globals.redirectBrowser(requestData.intendedUrl);

                                    } else {
                                        __globals.redirectBrowser(window.appConfig.appBaseURL);
                                    }

                                });
                            });

                    });

                };



				/**
                * Submit login form action
                *
                * @return void
                *---------------------------------------------------------------- */

                scope.submitDialogLogin = function () {

                    scope.isInActive = false;

                    __Form.process('user.login', scope).success(function (responseData) {

                        var requestData = responseData.data;

                        appServices.processResponse(responseData, {
                            error: function () {

                                // scope.isInActive = requestData.isInActive;

                                scope.show_captcha = requestData.show_captcha;

                                // reset password field
                                scope[scope.ngFormModelName].password = "";

                                // Check if show captcha exist then refresh captcha
                                if (scope.show_captcha) {
                                    scope[scope.ngFormModelName].confirmation_code = "";
                                    scope.refreshCaptcha();
                                }

                            },
                            otherError: function (reactionCode) {

                                scope.isInActive = requestData.isInActive;

                                // If reaction code is Server Side Validation Error Then 
                                // Unset the form fields
                                if (reactionCode == 3) {

                                    // Check if show captcha exist then refresh captcha
                                    if (scope.show_captcha) {
                                        scope.refreshCaptcha();
                                    }

                                } else if (reactionCode == 10) {
                                    if (requestData.auth_info.authorized) {
                                        window.location = window.appConfig.appBaseURL;
                                    }
                                }

                            }
                        },
                            function () {

                                __Auth.checkIn(requestData.auth_info, function () {

                                    if (scope.guestLogin == true) {
                                        __globals.redirectBrowser(__Utils.apiURL('order.summary.view'));
                                    } else {
                                        $scope.closeThisDialog({ 'login_success': true });
                                    }
                                });

                            });

                    });

                };

            }

        ]);

})();